import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { TrendingUp, TrendingDown, TrendingFlat } from '@mui/icons-material';

export interface StatusCardProps {
  title: string;
  count: number;
  trend: 'up' | 'down' | 'neutral';
  color?: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';
}

const StatusCard: React.FC<StatusCardProps> = ({
  title,
  count,
  trend,
  color = 'primary'
}) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="subtitle2" color="text.secondary">
          {title}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
          <Typography variant="h4" sx={{ mr: 2 }} color={color}>
            {count}
          </Typography>
          {trend === 'up' && <TrendingUp color="error" />}
          {trend === 'down' && <TrendingDown color="success" />}
          {trend === 'neutral' && <TrendingFlat color="disabled" />}
        </Box>
      </CardContent>
    </Card>
  );
};

export default StatusCard;
